<script>
    import { Router, Route, Link } from "svelte-navigator";
    import { MDBBtn, MDBContainer, MDBIcon, MDBInput } from "mdbsvelte";
    import Nav from "./components/Nav.svelte";
    import Dash from "./Dash.svelte";
    import Sales from "./Sales.svelte";
    import Products from "./Products.svelte";

    let showMobileNav = false;

    let title = "";

    const handleMobileNav = () => {
        showMobileNav = !showMobileNav;
    };

    function addTitle(event) {
        title = event.detail.text;
    }
</script>

<main>
    <Router primary={false}>
        <div class="mainContainer">
            <div class="sideCol">
                <div class="compNavHolder">
                    <Nav on:handleMenu={handleMobileNav} />
                </div>
            </div>
            <div class="mobileCol">
                <div class="gree twelve wide mcolumn" style="flex: 10;">
                    <div class="proTitle">
                        <span class="">
                            City<span class="rxName">Liquor</span>
                        </span>
                    </div>
                </div>
                <div class="orang four wide mcolumn" style="flex: 1;">
                    <div class="mobileNavTrigger">
                        <span>
                            <MDBIcon
                                on:click={handleMobileNav}
                                fas
                                icon="bars"
                                style="font-size:25px;"
                            />
                        </span>
                    </div>
                </div>
            </div>

            <!-- mobile nav -->
            {#if showMobileNav}
                <div class="mobileNavHolder">
                    <Nav on:handleMenu={handleMobileNav} />
                </div>
            {/if}
            <!-- mobile nav -->

            <div class="mainCol">
                <!-- topbar -->
                <div class="topbar">
                    <div class="titleCol">
                        <span
                            on:click={() => {
                                window.history.back();
                            }}
                            class="backIcon"
                            ><i class="ui left arrow icon" /> &nbsp;</span
                        >
                        <span class="title">{title}</span>
                    </div>
                    <div class="searchCol">
                        <div class="ui fluid icon input">
                            <input type="text" placeholder="Search..." />
                            <i style="color:aliceblue" class="search icon" />
                        </div>
                    </div>
                </div>

                <!-- topbar -->

                <Route path="/*">
                    <Dash on:addTitle={addTitle} />
                </Route>

                <Route path="/sales">
                    <Sales on:addTitle={addTitle} />
                </Route>

                <Route path="/products/*">
                    <Route path="/*">
                        <Products on:addTitle={addTitle} />
                    </Route>
                </Route>
            </div>
        </div>
    </Router>
</main>

<style>
    main {
        color: aliceblue;
        padding-top: 1em;
    }

    input {
        background: #181818 !important;
        border: none !important;
        border-bottom: 1px solid gray !important;
        color: aliceblue !important;
    }
    .mainContainer {
        display: flex;
        max-width: 80em;
        margin: auto;
        flex-direction: column;
    }

    .sideCol {
        display: none;
        flex: 1;
    }

    .mainCol {
        flex: 3;
        background: rgba(0, 0, 0, 0.123);
        margin: 1em;
        text-align: left;
        padding: 1em;
    }

    .mobileCol {
        padding-left: 1em;
        padding-right: 1em;
        display: flex;
        flex-direction: row;
        border-bottom: 1px solid rgba(223, 223, 223, 0.247);
    }

    .proTitle {
        font-weight: 600;
        font-size: 20px;
        text-align: left;
    }

    .mcolumn {
        display: flex;
    }

    .rxName {
        color: brown;
    }

    .mobileNavHolder {
        position: absolute;
        top: 3em;
        left: 0;
        width: 100%;
        z-index: 100;
    }

    .topbar {
        display: flex;
        border-bottom: 1px solid rgba(128, 128, 128, 0.349);
        padding-bottom: 10px;
    }

    .titleCol {
        flex: 1;
        font-weight: 600;
        padding-top: 1em;
    }

    .searchCol {
        flex: 1;
    }

    .backIcon {
        color: brown;
        cursor: pointer;
    }

    @media only screen and (min-width: 640px) {
        .mainContainer {
            display: flex;
            max-width: 80em;
            margin: auto;
            flex-direction: row;
        }

        .sideCol {
            display: block;
        }

        .mobileCol {
            display: none;
        }

        .mobileNavHolder {
            display: none;
        }
    }
</style>
